import React from 'react';
import CartItemCard from './CartItemCard';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { MdRemoveShoppingCart } from 'react-icons/md';
import { Col, Container, Row } from 'react-bootstrap';
import MetaData from '../MetaData';

const Cart = () => {
    const { cartItems } = useSelector((state) => state.cart);
    const navigate = useNavigate();

    const handleCheckout = () => {
        navigate('/login?redirect=shipping');
    };

    return (
        <>
            <MetaData title='Cart - ShipShop' />
            <Container>
                {cartItems && cartItems.length > 0 ? (
                    <div className='cart-page section-padding-bottom section-padding-top'>
                        <div className='cart-header'>
                            <p className='text-center'>Product</p>
                            <p className='text-center'>Quantity</p>
                            <p className='text-center'>Subtotal</p>
                        </div>
                        <div className='cartContainer'>
                            {cartItems &&
                                cartItems.length > 0 &&
                                cartItems.map((item) => (
                                    <CartItemCard key={item.product} item={item} />
                                ))}
                        </div>
                        <Row className='cartGrossTotal'>
                            <Col md={4} className='d-md-inline-block d-none'></Col>
                            <Col md={8} className='text-end'>
                                <div>
                                    <div className='d-flex justify-content-end'>
                                        <p className='me-5'>Gross Total:</p>
                                        <b>{`₹${cartItems.reduce(
                                            (acc, item) => acc + item.price * item.quantity,
                                            0
                                        )}`}</b>
                                    </div>
                                    <button
                                        className='checkoutBtn primary-btn'
                                        onClick={handleCheckout}
                                    >
                                        Checkout
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    <div className='noItems'>
                        <div>
                            <MdRemoveShoppingCart />
                            <p>No Items in Cart</p>
                            <Link to='/products' className='btn btn-primary'>
                                View Products
                            </Link>
                        </div>
                    </div>
                )}
            </Container>
        </>
    );
};

export default Cart;
